import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateAcceptModeration = {
  acceptModeration: { data: null, loading: false, error: null },
};

export const acceptModeration = createAsyncThunk('user/acceptModeration', async (id, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .post(
      `${process.env.REACT_APP_SERVER_API}/vacancies/${id}/moderation`,
      {},
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      },
    )
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerAcceptModeration = {
  [acceptModeration.pending]: (state) => {
    state.acceptModeration.loading = true;
    state.acceptModeration.error = null;
  },
  [acceptModeration.fulfilled]: (state, action) => {
    state.acceptModeration.loading = false;
    state.acceptModeration.data = true;
    state.acceptModeration.error = null;
  },
  [acceptModeration.rejected]: (state, action) => {
    state.acceptModeration.loading = false;
    state.acceptModeration.error = action.payload;
  },
};
